
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/opensearch",
      function () {
        return require("private-next-pages/destinations/opensearch.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/opensearch"])
      });
    }
  